<template>
  <footer class="site-footer">
    <p class="copyright">
      <small>&copy; {{ year }} Danilo Targas</small>
    </p>
  </footer>
</template>

<script setup lang="ts">
const year = new Date().getFullYear();
</script>

<style scoped lang="scss">
.site-footer {
  padding: 2rem 30px 3rem;
  text-align: center;
  opacity: 0.85;
}
</style>
